import { Maximize2, PartyPopper, Sparkles, type LucideIcon } from 'lucide-react';
import type { CelebrationKind } from './celebrations';

/** How each kind of celebration is shown: its pin on the timeline and its button. */
export const CELEBRATION_ICONS: Record<CelebrationKind, LucideIcon> = {
  confetti: PartyPopper,
  glow: Sparkles,
  zoom: Maximize2,
};

export const CELEBRATION_LABEL_KEYS: Record<CelebrationKind, string> = {
  confetti: 'shareClimb.celebrateConfetti',
  glow: 'shareClimb.celebrateGlow',
  zoom: 'shareClimb.celebrateZoom',
};

/** What each kind does, in the dialog it is picked from. */
export const CELEBRATION_DESCRIPTION_KEYS: Record<CelebrationKind, string> = {
  confetti: 'shareClimb.celebrateConfettiHint',
  glow: 'shareClimb.celebrateGlowHint',
  zoom: 'shareClimb.celebrateZoomHint',
};
